import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Box,
} from "@mui/material";
import React from "react";

interface FormDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void;
  isLoading?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  children: React.ReactNode;
}

export const FormDialog: React.FC<FormDialogProps> = ({
  open,
  title,
  onClose,
  onSubmit,
  isLoading = false,
  submitLabel = "Save",
  cancelLabel = "Cancel",
  maxWidth = "md",
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={maxWidth}
      PaperProps={{
        sx: {
          borderRadius: 1,
          boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "0.875rem",
          fontWeight: 600,
          borderBottom: "1px solid",
          borderColor: "divider",
          pb: 2,
        }}
      >
        {title}
      </DialogTitle>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <DialogContent sx={{ p: 3 }}>{children}</DialogContent>
        <DialogActions
          sx={{
            p: 2,
            borderTop: "1px solid",
            borderColor: "divider",
          }}
        >
          <Button
            onClick={onClose}
            size="medium"
            disabled={isLoading}
            sx={{
              fontSize: "0.8125rem",
              textTransform: "none",
              height: "36px",
              minWidth: "64px",
            }}
          >
            {cancelLabel}
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isLoading}
            size="medium"
            sx={{
              fontSize: "0.8125rem",
              textTransform: "none",
              fontWeight: 500,
              height: "36px",
              minWidth: "64px",
            }}
          >
            {isLoading ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={16} color="inherit" />
                <span>{submitLabel}</span>
              </Box>
            ) : (
              submitLabel
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
